import { useQuery } from '@apollo/client';
import { Account } from '@bakerweb/models';
import { GET_ACCOUNTS } from '../graphql/queries/getAccounts';

export const useGetAccounts = () => {
  const { loading, error, data, refetch } = useQuery<{ accounts: Account[] }>(GET_ACCOUNTS);

  const accounts = data?.accounts ?? [];

  return { loading, error, accounts, refetch };
};
